<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="profile-page">

    <!-- PROFILE HEADER -->
    <listing-header
      :data="data"
      :activeMenu="header.activeMenu"
      :menus="header.menus"
      @menu-changed="header.activeMenu = $event"
    />

    <!-- Profile -->
    <div class="vx-row content-row" v-if="header.activeMenu == 'Profile'">
      <!-- <listing-category :loading="loading" /> -->

      <!-- left column -->
      <div class="vx-col w-full lg:w-1/4">
        <listing-info :data="data" />
        <listing-contact :data="data" />
        <listing-social-media :data="data.socmedLink || {}" />
        <!-- <listing-maps :loading="loading" /> -->
      </div>
      <!-- ./ left column -->

      <!-- middle column -->
      <div class="vx-col w-full lg:w-1/2 xs-order__-1">
        <listing-description :data="data" />
        <listing-work-hour :data="computedWorkHour" @update="updateWorkHour" />
        <listing-feature :listing-id="listingId" />
      </div>
      <!-- ./ middle column -->

      <!-- right column -->
      <div class="vx-col w-full lg:w-1/4">
        <listing-maps :data="data" />
        <listing-photo :listing-id="listingId" />
      </div>
      <!-- ./ right column -->

    </div>
    <!-- ./ Profile -->

    <!-- Posts -->
    <div class="vx-row content-row" v-if="header.activeMenu == 'Posts'">
      <!-- <post-list :listing-id="id" /> -->
    </div>
    <!-- ./ Posts -->

    <!-- Reviews -->
    <div class="vx-row content-row" v-if="header.activeMenu == 'Reviews'">
      <p>Reviews</p>
    </div>
    <!-- ./ Reviews -->

    <vs-button color="primary" type="border" icon="save" class="save-button" @click="update"></vs-button>

  </div>
</template>

<script>
export default {
  data () {
    return {
      wasSidebarOpen: null,
      header: {
        activeMenu: 'Profile',
        menus: [
          'Profile',
          'Posts',
          'Reviews'
        ]
      },
      data: {
        workHour: {},
        maps: {}
      },
    }
  },
  metaInfo() {
    return {
      title: this.data.name,
      meta: [
        { name: 'description', content: this.computedExcerpt || 'JogjaBagus Listing Information' }
      ]
    };
  },
  computed: {
    listingId () {
      return this.$route.params.id
    },
    // data() {
    //   return this.$store.getters['businessDoc/data']
    // },
    computedWorkHour () {
      return {
        sunday: this.data.workHour.sunday || { open: false, from: '', to: '' },
        monday: this.data.workHour.monday || { open: false, from: '', to: '' },
        tuesday: this.data.workHour.tuesday || { open: false, from: '', to: '' },
        wednesday: this.data.workHour.wednesday || { open: false, from: '', to: '' },
        thursday: this.data.workHour.thursday || { open: false, from: '', to: '' },
        friday: this.data.workHour.friday || { open: false, from: '', to: '' },
        saturday: this.data.workHour.saturday || { open: false, from: '', to: '' }
      }
    },
  },
  methods: {
    updateWorkHour(data) {
      const temp = { ...this.computedWorkHour }
      temp[data.day] = data

      this.data.workHour = { ...temp }
    },
    update() {
      this.$vs.loading();
      this.$store.dispatch('businessDoc/setData', this.data)
        .then(() => {
          this.notifySuccess('Data updated')
        })
        .catch(err => {
          this.notifySuccess(err.message)
        })
        .then(() => this.$vs.loading.close())
    }
  },
  components: {
    ListingHeader: () => { return import('./_show/ListingHeader.vue') },
    ListingInfo: () => { return import('./_show/ListingInfo.vue') },
    ListingContact: () => { return import('./_show/ListingContact.vue') },
    ListingSocialMedia: () => { return import('./_show/ListingSocialMedia.vue') },
    ListingDescription: () => { return import('./_show/ListingDescription.vue') },
    ListingWorkHour: () => { return import('./_show/ListingWorkHour.vue') },
    ListingFeature: () => { return import('./_show/ListingFeature.vue') },
    ListingMaps: () => { return import('./_show/ListingMaps.vue') },
    ListingPhoto: () => { return import('./_show/ListingPhoto.vue') },
  },
  mounted () {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit('TOGGLE_REDUCE_BUTTON', true)
    this.$store.dispatch('businessDoc/openDBChannel', { businessId: this.$route.params.id, includeMetadataChanges: true })
    this.$store.dispatch('business/fetchById', this.$route.params.id)
      .then(snapshot => {
        this.data = { ...snapshot }
      })
  },
  beforeDestroy () {
    if (!this.wasSidebarOpen) this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
    // await this.$store.dispatch('businessDoc/closeDBChannel', {clearModule: true})
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/pages/profile.scss";
@import "breakpoint-sass";

.save-button {
  position: fixed;
  right: 35px;
  bottom: 35px;
}

.content-row {
  margin-left: 5px;
  margin-right: 5px;
}

.order__-1 {
  order: -1;
}

.xs-order__-1 {
  order: -1;

  @include breakpoint(992px) {
    order: 0;
  }
}
</style>
